import React from 'react';

import { Container, ContainerInner } from './CustomPaper.styles';

type Props = {
  elevation?: number;
  alpha?: number;
  children: React.ReactNode;
};

export default (props: Props) => (
  <Container {...props} className="ro-paper">
    <ContainerInner>{props.children}</ContainerInner>
  </Container>
);
